/**
 * Light / dark.
 *
 * index.html da doc localStorage va dat class "dark" tren <html> TRUOC khi React mount
 * (de khong nhay trang mot nhip khi tai lai). File nay chi tiep tuc dung dung khoa do.
 */

export const THEME_STORAGE_KEY = 'capforge.theme';

export type Theme = 'light' | 'dark';

export function readTheme(): Theme {
  // Nguon su that la class tren <html>: index.html da tinh ra no tu localStorage
  // hoac tu prefers-color-scheme, nen doc lai class la khop voi cai dang hien.
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
}

export function applyTheme(theme: Theme): void {
  document.documentElement.classList.toggle('dark', theme === 'dark');
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // Khong luu duoc thi theme chi song trong phien nay — chap nhan duoc.
  }
}
